module.exports = ".intro{\r\n  text-align: center;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/services-assigment/services-assigment.component.css
// module id = ./src/app/components/services-assigment/services-assigment.component.css
// module chunks = main